<template>
    <span class="PersonEditor">
        <span v-if="Inline == false"><span class="pointer underline" v-bind:class="PersonLabelClass" @click="ShowEditModal()"> {{ ExistingPerson.FullName }} </span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" v-on:click="ShowEditModal()" class="pointer" /></span>
        <div v-if="Inline == true">
            <b-form @submit="Save">
                <b-row>
                    <b-col>
                        <h3>Name</h3>
                        <div class="form-group">
                            <label>First Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.FirstName" required />
                        </div>
                        <div class="form-group">
                            <label>AKA:</label>
                            <input class="form-control" v-model="UpdatedPerson.AKA" />
                        </div>
                        <div class="form-group">
                            <label>Middle Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.MiddleName" />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.LastName" required />
                        </div>
                        <div class="form-group">
                            <label>Suffix:</label>
                            <input class="form-control" v-model="UpdatedPerson.Suffix" />
                        </div>
                    </b-col>
                    <b-col v-if="!HidePersonalInfo">
                        <h3>Personal Info</h3>
                        <div>
                            <label>DOB:</label>
                            <flat-pickr v-model="UpdatedPerson.DOB" class="form-control" v-bind:required="DOBRequired" :config="DateConfig"></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>SSN:</label>
                            <input class="form-control" v-model="UpdatedPerson.SSN" />
                        </div>
                        <h3>Demographics</h3>
                        <div>
                            <label>Sex:</label>
                            <select class="form-control" v-model="UpdatedPerson.SexID">
                                <option v-for="option in SexOptions" :value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                        <div>
                            <label>Race:</label>
                            <select class="form-control" v-model="UpdatedPerson.RaceID">
                                <option v-for="option in RaceOptions" :value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                        <div>
                            <label>Ethnicity:</label>
                            <select class="form-control" v-model="UpdatedPerson.EthnicityID">
                                <option v-for="option in EthnicityOptions" :value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                        <div v-if="IncludeLanguage">
                            <label>Language:</label>
                            <select class="form-control" v-model="UpdatedPerson.Language">
                                <option :value="null"></option>
                                <option value="English">English</option>
                                <option value="Spanish">Spanish</option>
                                <option value="Mandarin">Mandarin</option>
                                <option value="Tagalog">Tagalog</option>
                                <option value="Vietnamese">Vietnamese</option>
                                <option value="Other">Other (contact support to add option)</option>
                            </select>
                        </div>
                        <div v-if="IncludeIsDisabled">
                            <label>Disabled:</label>
                            <select class="form-control" v-model="UpdatedPerson.IsDisabled">
                                <option :value="null"></option>
                                <option :value="true">Yes</option>
                                <option :value="false">No</option>
                            </select>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="EmployeeRecord != undefined">
                    <b-col cols="6">
                        <h3>Outside Systems</h3>
                        <div>
                            <label>Welligent Provider ID:</label>
                            <input class="form-control" v-model="UpdatedPerson.WelligentProviderID" />
                        </div>
                        <div>
                            <label>Avatar Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.AvatarName" />
                        </div>
                        <div>
                            <label>Previous Avatar Names (Pipe Separated | ):</label>
                            <input class="form-control" v-model="UpdatedPerson.PreviousAvatarProviderNames" />
                        </div>
                        <div>
                            <label>San Bernardino Provider ID:</label>
                            <input class="form-control" v-model="UpdatedPerson.SanBernardinoProviderID" />
                        </div>
                    </b-col>
                    <b-col>
                        <h3>Professional Details</h3>
                        <div>
                            <label>License Number:</label>
                            <input class="form-control" v-model="UpdatedPerson.LicenseNumber" />
                        </div>
                        <div>
                            <label>License Type:</label>
                            <select class="form-control" v-model="UpdatedPerson.LicenseType">
                                <option value=""></option>
                                <option value="AMFT">AMFT</option>
                                <option value="ASW">ASW</option>
                                <option value="APCC">APCC</option>
                                <option value="LPCC">LPCC</option>
                                <option value="LCSW">LCSW</option>
                                <option value="LMFT">LMFT</option>
                                <option value="Ph.D.">Ph.D.</option>
                                <option value="MFT Trainee">MFT Trainee</option>
                                <option value="MFT Intern">MSW Intern</option>
                                <option value="PCC Tainee">PCC Trainee</option>
                            </select>
                        </div>
                        <div>
                            <label>Professional Title:</label>
                            <select class="form-control" v-model="UpdatedPerson.ProfessionalTitle">
                                <option value=""></option>
                                <option value="Registered Associate Marriage and Family Therapist">Registered Associate Marriage and Family Therapist</option>
                                <option value="Registered Associate Clinical Social Worker">Registered Associate Clinical Social Worker</option>
                                <option value="Registered Associate Professional Clinical Counselor">Registered Associate Professional Clinical Counselor</option>
                                <option value="Licensed Professional Clinical Counselor">Licensed Professional Clinical Counselor</option>
                                <option value="Licensed Clinical Social Worker">Licensed Clinical Social Worker</option>
                                <option value="Licensed Marriage and Family Therapist">Licensed Marriage and Family Therapist</option>
                                <option value="MFT Trainee">Marriage and Family Therapist Trainee</option>
                                <option value="MFT Intern">Master of Social Work Intern</option>
                                <option value="PCC Tainee">Professional Clinical Counselor Trainee</option>
                            </select>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwParentTracking">
                    <b-col>
                        <h3>Document Expirations</h3>
                        <div>
                            <label>DL Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.DriverLicenseExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>CPR Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.CPRExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>First Aid Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.FirstAidExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Car Insurance Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.CarInsuranceExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <div>
                            <label>Last Flu Shot:</label>
                            <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last Pertussis:</label>
                            <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last TB Test:</label>
                            <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>BBP Training Date:</label>
                            <flat-pickr v-model="UpdatedPerson.HIVDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwFamilyTracking">
                    <b-col>
                        <h3>Background/Clearances</h3>
                        <div>
                            <label>Background Check (16):</label>
                            <select class="form-control" v-model="UpdatedPerson.BC16Obtained">
                                <option :value="null"></option>
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                        </div>
                        <div>
                            <label>Background Check (18):</label>
                            <select class="form-control" v-model="UpdatedPerson.BC18Obtained">
                                <option :value="null"></option>
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                        </div>
                        <div>
                            <label>Fingerprints Obtained:</label>
                            <select class="form-control" v-model="UpdatedPerson.FingerPrintsObtained">
                                <option :value="null"></option>
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                        </div>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <div>
                            <label>Last Flu Shot:</label>
                            <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last Pertussis:</label>
                            <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last TB Test:</label>
                            <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwBabysitterTracking">
                    <b-col>
                        <h3>Document Dates</h3>
                        <div>
                            <label>DL Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.DriverLicenseExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>CPR Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.CPRExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>First Aid Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.FirstAidExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Car Insurance Expiration:</label>
                            <flat-pickr v-model="UpdatedPerson.CarInsuranceExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Policy Agreement Signed:</label>
                            <flat-pickr v-model="UpdatedPerson.PolicyAgreementSignedDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Fingerprint Notice:</label>
                            <flat-pickr v-model="UpdatedPerson.FingerPrintNoticeDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>BCCU Sent:</label>
                            <select class="form-control" v-model="UpdatedPerson.BCCUSent">
                                <option :value="null"></option>
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                        </div>
                        <div>
                            <label>BCCU Cleared Date:</label>
                            <flat-pickr v-model="UpdatedPerson.BCCUClearedDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <div>
                            <label>Last Flu Shot:</label>
                            <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last Pertussis:</label>
                            <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                        <div>
                            <label>Last TB Test:</label>
                            <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <div class="form-group">
                            <label>Email:</label>
                            <input class="form-control" v-model="UpdatedPerson.Email" />
                        </div>
                        <h3>Phone Numbers <font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddNewPhoneNumber()" class="pointer olive-green-text" /> </h3>

                        <div v-for="(phoneNumber, phoneIndex) in UpdatedPerson.PhoneNumbers">
                            <p class="bold">Phone #{{ phoneIndex + 1 }}: <font-awesome-icon :icon="['fa', 'trash-alt']" v-on:click="DeletePhoneNumber(phoneIndex)" class="pointer red" /></p>
                            <div class="form-group">
                                <label>Phone Number:</label>
                                <input class="form-control" v-model="phoneNumber.PhoneNumber" required />
                            </div>
                            <div class="form-group">
                                <label>Type:</label>
                                <select class="form-control" v-model="phoneNumber.PhoneType" required>
                                    <option value="Cell">Cell</option>
                                    <option value="Home">Home</option>
                                    <option value="Work">Work</option>
                                    <option value="Google">Google</option>
                                    <option value="Fax">Fax</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <input class="form-control" v-model="phoneNumber.Description" />
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="IsStrongFamilyContactable">
                    <b-col>
                        <div class="form-group">
                            <label>Text Message Hosting Alerts:</label>
                            <select class="form-control" v-model="UpdatedPerson.IsSMSContactOk">
                                <option :value="true">ON</option>
                                <option :value="false">OFF</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Email Hosting Alerts:</label>
                            <select class="form-control" v-model="UpdatedPerson.IsEmailContactOk">
                                <option :value="true">ON</option>
                                <option :value="false">OFF</option>
                            </select>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row" v-if="ControlButtons">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="success" type="submit">
                            SAVE
                        </b-button>
                    </div>
                </b-row>
            </b-form>
        </div>
        <b-modal v-if="Inline == false" ref="component-modal" :title="ExistingPerson.FullName" hide-footer :modal-class="IncludeParentCharting ? 'full-screen-modal' : ''">
            <b-container v-if="EditMode == false">
                <b-row>
                    <b-col>
                        <h3>Name</h3>
                        <p><span class="bold">First Name: </span>{{ ExistingPerson.FirstName }}</p>
                        <p v-if="ExistingPerson.AKA"><span class="bold">AKA: </span>{{ ExistingPerson.AKA }}</p>
                        <p v-if="ExistingPerson.MiddleName"><span class="bold">Middle Name: </span>{{ ExistingPerson.MiddleName }}</p>
                        <p><span class="bold">Last Name: </span>{{ ExistingPerson.LastName }}</p>
                        <p v-if="ExistingPerson.Suffix"><span class="bold">Suffix: </span>{{ ExistingPerson.Suffix }}</p>
                    </b-col>
                    <b-col v-if="!HidePersonalInfo">
                        <h3>Personal Info</h3>
                        <p v-if="ExistingPerson.DOB"><span class="bold">DOB: </span>{{ formatDate(ExistingPerson.DOB,'MM/DD/YY') }}</p>
                        <p v-if="ExistingPerson.DOB"><span class="bold">Age: </span>{{ ExistingPerson.AgeString }}</p>
                        <p v-if="ExistingPerson.SSN"><span class="bold">SSN: </span>{{ ExistingPerson.FormattedSSN }}</p>
                        <h3>Demographics</h3>
                        <p v-if="ExistingPerson.Sex"><span class="bold">Sex: </span>{{ ExistingPerson.Sex.Name }}</p>
                        <p v-if="ExistingPerson.Race"><span class="bold">Race: </span>{{ ExistingPerson.Race.Name }}</p>
                        <p v-if="ExistingPerson.Ethnicity"><span class="bold">Ethnicity: </span>{{ ExistingPerson.Ethnicity.Name }}</p>
                        <p><span class="bold">Language: </span>{{ ExistingPerson.Language }}</p>
                        <p><span class="bold">Disabled: </span>{{ ExistingPerson.IsDisabled }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwParentTracking">
                    <b-col>
                        <h3>Document Expirations</h3>
                        <p><span class="bold">DL Expiration: </span>{{ formatDate(ExistingPerson.DriverLicenseExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">CPR Expiration: </span>{{ formatDate(ExistingPerson.CPRExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">First Aid Expiration: </span>{{ formatDate(ExistingPerson.FirstAidExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Car Insurance Expiration: </span>{{ formatDate(ExistingPerson.CarInsuranceExpirationDate,'MM/DD/YY') }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(ExistingPerson.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(ExistingPerson.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(ExistingPerson.TBVaccinationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last BBP Training Date: </span>{{ formatDate(ExistingPerson.HIVDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwFamilyTracking">
                    <b-col>
                        <h3>Background/Clearances</h3>
                        <p><span class="bold">Background Check (16): </span>{{ ExistingPerson.BC16Obtained != null ? ExistingPerson.BC16Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Background Check (18): </span>{{ ExistingPerson.BC18Obtained != null ? ExistingPerson.BC18Obtained == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">Fingerprints Obtained: </span>{{ ExistingPerson.FingerPrintsObtained != null ? ExistingPerson.FingerPrintsObtained == true ? 'Yes' : 'No' : '' }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(ExistingPerson.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(ExistingPerson.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(ExistingPerson.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludePnwBabysitterTracking">
                    <b-col>
                        <h3>Document Dates</h3>
                        <p><span class="bold">DL Expiration: </span>{{ formatDate(ExistingPerson.DriverLicenseExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">CPR Expiration: </span>{{ formatDate(ExistingPerson.CPRExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">First Aid Expiration: </span>{{ formatDate(ExistingPerson.FirstAidExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Car Insurance Expiration: </span>{{ formatDate(ExistingPerson.CarInsuranceExpirationDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Policy Agreement Signed: </span>{{ formatDate(ExistingPerson.PolicyAgreementSignedDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Fingerprint Notice: </span>{{ formatDate(ExistingPerson.FingerPrintNoticeDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">BCCU Sent: </span>{{ ExistingPerson.BCCUSent != null ? ExistingPerson.BCCUSent == true ? 'Yes' : 'No' : '' }}</p>
                        <p><span class="bold">BCCU Cleared Date: </span>{{ formatDate(ExistingPerson.BCCUClearedDate,'MM/DD/YY') }}</p>
                    </b-col>
                    <b-col>
                        <h3>Vaccinations/Tests</h3>
                        <p><span class="bold">Last Flu Shot: </span>{{ formatDate(ExistingPerson.FluShotDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last Pertussis: </span>{{ formatDate(ExistingPerson.PertussisDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">Last TB Test: </span>{{ formatDate(ExistingPerson.TBVaccinationDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <p v-if="ExistingPerson.Email"><span class="bold">Email: </span>{{ ExistingPerson.Email }}</p>
                        <p v-for="(phoneNumber, phoneIndex) in TargetPersonPhoneNumbers">
                            <span class="bold">{{ phoneNumber.PhoneType }}: </span>{{ phoneNumber.PhoneNumber }} {{ phoneNumber.Description ? '(' + phoneNumber.Description + ')' : '' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="IncludeParentCharting">
                    <CaseFile chart-type="FosterResourceParent"
                              :chart-record-id="ParentId" />
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CANCEL
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-else>
                <b-form @submit="Save">
                    <b-row>
                        <b-col>
                            <h3>Name</h3>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input class="form-control" v-model="UpdatedPerson.FirstName" required />
                            </div>
                            <div class="form-group">
                                <label>AKA:</label>
                                <input class="form-control" v-model="UpdatedPerson.AKA" />
                            </div>
                            <div class="form-group">
                                <label>Middle Name:</label>
                                <input class="form-control" v-model="UpdatedPerson.MiddleName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input class="form-control" v-model="UpdatedPerson.LastName" required />
                            </div>
                            <div class="form-group">
                                <label>Suffix:</label>
                                <input class="form-control" v-model="UpdatedPerson.Suffix" />
                            </div>
                        </b-col>
                        <b-col v-if="HidePersonalInfo != true">
                            <h3>Personal Info</h3>
                            <div>
                                <label>DOB:</label>
                                <flat-pickr v-model="UpdatedPerson.DOB" class="form-control" v-bind:required="DOBRequired" :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>SSN:</label>
                                <input class="form-control" v-model="UpdatedPerson.SSN" />
                            </div>
                            <h3>Demographics</h3>
                            <div>
                                <label>Sex:</label>
                                <select class="form-control" v-model="UpdatedPerson.SexID">
                                    <option v-for="option in SexOptions" :value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div>
                                <label>Race:</label>
                                <select class="form-control" v-model="UpdatedPerson.RaceID">
                                    <option v-for="option in RaceOptions" :value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div>
                                <label>Ethnicity:</label>
                                <select class="form-control" v-model="UpdatedPerson.EthnicityID">
                                    <option v-for="option in EthnicityOptions" :value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div v-if="IncludeLanguage">
                                <label>Language:</label>
                                <select class="form-control" v-model="UpdatedPerson.Language">
                                    <option :value="null"></option>
                                    <option value="English">English</option>
                                    <option value="Spanish">Spanish</option>
                                    <option value="Mandarin">Mandarin</option>
                                    <option value="Tagalog">Tagalog</option>
                                    <option value="Vietnamese">Vietnamese</option>
                                    <option value="Other">Other (contact support to add option)</option>
                                </select>
                            </div>
                            <div v-if="IncludeIsDisabled">
                                <label>Disabled:</label>
                                <select class="form-control" v-model="UpdatedPerson.IsDisabled">
                                    <option :value="null"></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="IncludePnwParentTracking">
                        <b-col>
                            <h3>Document Expirations</h3>
                            <div>
                                <label>DL Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.DriverLicenseExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>CPR Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.CPRExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>First Aid Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.FirstAidExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Car Insurance Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.CarInsuranceExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Vaccinations/Tests</h3>
                            <div>
                                <label>Last Flu Shot:</label>
                                <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last Pertussis:</label>
                                <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last TB Test:</label>
                                <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>BBP Training Date:</label>
                                <flat-pickr v-model="UpdatedPerson.HIVDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="IncludePnwFamilyTracking">
                        <b-col>
                            <h3>Background/Clearances</h3>
                            <div>
                                <label>Background Check (16):</label>
                                <select class="form-control" v-model="UpdatedPerson.BC16Obtained">
                                    <option :value="null"></option>
                                    <option :value="false">No</option>
                                    <option :value="true">Yes</option>
                                </select>
                            </div>
                            <div>
                                <label>Background Check (18):</label>
                                <select class="form-control" v-model="UpdatedPerson.BC18Obtained">
                                    <option :value="null"></option>
                                    <option :value="false">No</option>
                                    <option :value="true">Yes</option>
                                </select>
                            </div>
                            <div>
                                <label>Fingerprints Obtained:</label>
                                <select class="form-control" v-model="UpdatedPerson.FingerPrintsObtained">
                                    <option :value="null"></option>
                                    <option :value="false">No</option>
                                    <option :value="true">Yes</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Vaccinations/Tests</h3>
                            <div>
                                <label>Last Flu Shot:</label>
                                <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last Pertussis:</label>
                                <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last TB Test:</label>
                                <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="IncludePnwBabysitterTracking">
                        <b-col>
                            <h3>Document Dates</h3>
                            <div>
                                <label>DL Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.DriverLicenseExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>CPR Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.CPRExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>First Aid Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.FirstAidExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Car Insurance Expiration:</label>
                                <flat-pickr v-model="UpdatedPerson.CarInsuranceExpirationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Policy Agreement Signed:</label>
                                <flat-pickr v-model="UpdatedPerson.PolicyAgreementSignedDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Fingerprint Notice:</label>
                                <flat-pickr v-model="UpdatedPerson.FingerPrintNoticeDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>BCCU Sent:</label>
                                <select class="form-control" v-model="UpdatedPerson.BCCUSent">
                                    <option :value="null"></option>
                                    <option :value="false">No</option>
                                    <option :value="true">Yes</option>
                                </select>
                            </div>
                            <div>
                                <label>BCCU Cleared Date:</label>
                                <flat-pickr v-model="UpdatedPerson.BCCUClearedDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Vaccinations/Tests</h3>
                            <div>
                                <label>Last Flu Shot:</label>
                                <flat-pickr v-model="UpdatedPerson.FluShotDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last Pertussis:</label>
                                <flat-pickr v-model="UpdatedPerson.PertussisDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                            <div>
                                <label>Last TB Test:</label>
                                <flat-pickr v-model="UpdatedPerson.TBVaccinationDate" class="form-control" v-bind:required="false" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Contact Info</h3>
                            <div class="form-group">
                                <label>Email:</label>
                                <input class="form-control" v-model="UpdatedPerson.Email" />
                            </div>
                            <h3>Phone Numbers <font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddNewPhoneNumber()" class="pointer olive-green-text" /> </h3>

                            <div v-for="(phoneNumber, phoneIndex) in UpdatedPerson.PhoneNumbers">
                                <p class="bold">Phone #{{ phoneIndex + 1 }}: <font-awesome-icon :icon="['fa', 'trash-alt']" v-on:click="DeletePhoneNumber(phoneIndex)" class="pointer red" /></p>
                                <div class="form-group">
                                    <label>Phone Number:</label>
                                    <input class="form-control" v-model="phoneNumber.PhoneNumber" required />
                                </div>
                                <div class="form-group">
                                    <label>Type:</label>
                                    <select class="form-control" v-model="phoneNumber.PhoneType" required>
                                        <option value="Cell">Cell</option>
                                        <option value="Home">Home</option>
                                        <option value="Work">Work</option>
                                        <option value="Google">Google</option>
                                        <option value="Fax">Fax</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Description:</label>
                                    <input class="form-control" v-model="phoneNumber.Description" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="UpdatedPerson.Id && IncludeParentCharting">
                        <b-col>
                            <h3>Add Document</h3>
                            <NewDocument :form-memberships="ParentFormMemberships"
                                         :chart-record-id="ParentId" />
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row" v-if="ControlButtons">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import NewDocument from "../RecordComponents/NewDocument.vue";
    import CaseFile from "../RecordComponents/CaseFile.vue";

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "DOBRequired",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "ExistingPerson",//Person.cs object
            "Inline",//bool
            "EndPoint",//string
            "ControlButtons",
            "IncludeParentCharting",//bool
            "ParentId",//string
            "SubProgramId",//string
            "PersonLabelClass",//string
            "IncludePnwParentTracking",//bool
            "IncludePnwFamilyTracking",//bool
            "IncludePnwBabysitterTracking",//bool
            "ChartId",
            "HidePersonalInfo",//bool
            "EmployeeRecord", //Employee.cs object
            "IsStrongFamilyContactable",//bool
            "IncludeIsDisabled",//bool
            "IncludeLanguage",//bool
        ],
        data: function () {
            return {
                UpdatedPerson: {
                    Id: "",
                    FirstName: "",
                    AKA: "",
                    MiddleName: "",
                    LastName: "",
                    Suffix: "",
                    DOB: "",
                    SSN: "",
                    SexID: "",
                    RaceID: "",
                    EthnicityID: "",
                    Email: "",
                    PhoneNumbers: [],
                    DriverLicenseExpirationDate: "",
                    CPRExpirationDate: "",
                    FirstAidExpirationDate: "",
                    HIVDate: "",
                    CarInsuranceExpirationDate: "",
                    FluShotDate: "",
                    PertussisDate: "",
                    TBVaccinationDate: "",
                    BC16Obtained: "",
                    BC18Obtained: "",
                    FingerPrintsObtained: "",
                    PolicyAgreementSignedDate: "",
                    FingerPrintNoticeDate: "",
                    BCCUClearedDate: "",
                    BCCUSent: "",
                    WelligentProviderID: "",
                    AvatarName: "",
                    SanBernardinoProviderID: "",
                    PreviousAvatarProviderNames: "",
                    LicenseNumber: "",
                    LicenseType: "",
                    ProfessionalTitle: "",
                    IsSMSContactOk: "",
                    IsEmailContactOk: "",
                    Language: null,
                    IsDisabled: null,
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            GetUpdatedPerson: function() {
                return this.UpdatedPerson;
            },
            ImportExistingPerson() {
                let vm = this;
                if (this.ExistingPerson) {
                    this.UpdatedPerson.Id = this.ExistingPerson.Id
                    this.UpdatedPerson.FirstName = this.ExistingPerson.FirstName;
                    this.UpdatedPerson.AKA = this.ExistingPerson.AKA;
                    this.UpdatedPerson.MiddleName = this.ExistingPerson.MiddleName;
                    this.UpdatedPerson.LastName = this.ExistingPerson.LastName;
                    this.UpdatedPerson.Suffix = this.ExistingPerson.Suffix;
                    this.UpdatedPerson.DOB = this.ExistingPerson.DOB;
                    this.UpdatedPerson.SSN = this.ExistingPerson.SSN;
                    this.UpdatedPerson.SexID = this.ExistingPerson.SexID;
                    this.UpdatedPerson.RaceID = this.ExistingPerson.RaceID;
                    this.UpdatedPerson.EthnicityID = this.ExistingPerson.EthnicityID;
                    this.UpdatedPerson.Email = this.ExistingPerson.Email;
                    this.UpdatedPerson.DriverLicenseExpirationDate = this.ExistingPerson.DriverLicenseExpirationDate;
                    this.UpdatedPerson.CPRExpirationDate = this.ExistingPerson.CPRExpirationDate;
                    this.UpdatedPerson.FirstAidExpirationDate = this.ExistingPerson.FirstAidExpirationDate;
                    this.UpdatedPerson.HIVDate = this.ExistingPerson.HIVDate;
                    this.UpdatedPerson.CarInsuranceExpirationDate = this.ExistingPerson.CarInsuranceExpirationDate;
                    this.UpdatedPerson.FluShotDate = this.ExistingPerson.FluShotDate;
                    this.UpdatedPerson.PertussisDate = this.ExistingPerson.PertussisDate;
                    this.UpdatedPerson.TBVaccinationDate = this.ExistingPerson.TBVaccinationDate;
                    this.UpdatedPerson.BC16Obtained = this.ExistingPerson.BC16Obtained;
                    this.UpdatedPerson.BC18Obtained = this.ExistingPerson.BC18Obtained;
                    this.UpdatedPerson.FingerPrintsObtained = this.ExistingPerson.FingerPrintsObtained;
                    this.UpdatedPerson.PolicyAgreementSignedDate = this.ExistingPerson.PolicyAgreementSignedDate;
                    this.UpdatedPerson.FingerPrintNoticeDate = this.ExistingPerson.FingerPrintNoticeDate;
                    this.UpdatedPerson.BCCUClearedDate = this.ExistingPerson.BCCUClearedDate;
                    this.UpdatedPerson.BCCUSent = this.ExistingPerson.BCCUSent;
                    this.UpdatedPerson.IsSMSContactOk = this.ExistingPerson.IsSMSContactOk;
                    this.UpdatedPerson.IsEmailContactOk = this.ExistingPerson.IsEmailContactOk;
                    this.UpdatedPerson.IsDisabled = this.ExistingPerson.IsDisabled;
                    this.UpdatedPerson.Language = this.ExistingPerson.Language;
                    
                    this.UpdatedPerson.AvatarName = this.ExistingPerson.AvatarProviderName;
                    this.UpdatedPerson.SanBernardinoProviderID = this.ExistingPerson.SanBernardinoProviderID;
                    this.UpdatedPerson.PreviousAvatarProviderNames = this.ExistingPerson.PreviousAvatarProviderNames;
                    if (this.EmployeeRecord != undefined) {
                        this.UpdatedPerson.WelligentProviderID = this.EmployeeRecord.WelligentID;
                    }
                    this.UpdatedPerson.LicenseNumber = this.ExistingPerson.LicenseNumber;
                    this.UpdatedPerson.LicenseType = this.ExistingPerson.LicenseType;
                    this.UpdatedPerson.ProfessionalTitle = this.ExistingPerson.ProfessionalTitle;
                    //import phone numbers
                
                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            vm.UpdatedPerson.PhoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                
            },
            ShowEditModal() {
                this.UpdatedPerson.PhoneNumbers = [];
                let vm = this;

                if (this.ExistingPerson) {
                    this.UpdatedPerson.Id = this.ExistingPerson.Id
                    this.UpdatedPerson.FirstName = this.ExistingPerson.FirstName;
                    this.UpdatedPerson.AKA = this.ExistingPerson.AKA;
                    this.UpdatedPerson.MiddleName = this.ExistingPerson.MiddleName;
                    this.UpdatedPerson.LastName = this.ExistingPerson.LastName;
                    this.UpdatedPerson.Suffix = this.ExistingPerson.Suffix;
                    this.UpdatedPerson.DOB = this.ExistingPerson.DOB;
                    this.UpdatedPerson.SSN = this.ExistingPerson.SSN;
                    this.UpdatedPerson.SexID = this.ExistingPerson.SexID;
                    this.UpdatedPerson.RaceID = this.ExistingPerson.RaceID;
                    this.UpdatedPerson.EthnicityID = this.ExistingPerson.EthnicityID;
                    this.UpdatedPerson.Email = this.ExistingPerson.Email;
                    this.UpdatedPerson.DriverLicenseExpirationDate = this.ExistingPerson.DriverLicenseExpirationDate;
                    this.UpdatedPerson.CPRExpirationDate = this.ExistingPerson.CPRExpirationDate;
                    this.UpdatedPerson.FirstAidExpirationDate = this.ExistingPerson.FirstAidExpirationDate;
                    this.UpdatedPerson.HIVDate = this.ExistingPerson.HIVDate;
                    this.UpdatedPerson.CarInsuranceExpirationDate = this.ExistingPerson.CarInsuranceExpirationDate;
                    this.UpdatedPerson.FluShotDate = this.ExistingPerson.FluShotDate;
                    this.UpdatedPerson.PertussisDate = this.ExistingPerson.PertussisDate;
                    this.UpdatedPerson.TBVaccinationDate = this.ExistingPerson.TBVaccinationDate;
                    this.UpdatedPerson.BC16Obtained = this.ExistingPerson.BC16Obtained;
                    this.UpdatedPerson.BC18Obtained = this.ExistingPerson.BC18Obtained;
                    this.UpdatedPerson.FingerPrintsObtained = this.ExistingPerson.FingerPrintsObtained;
                    this.UpdatedPerson.PolicyAgreementSignedDate = this.ExistingPerson.PolicyAgreementSignedDate;
                    this.UpdatedPerson.FingerPrintNoticeDate = this.ExistingPerson.FingerPrintNoticeDate;
                    this.UpdatedPerson.BCCUClearedDate = this.ExistingPerson.BCCUClearedDate;
                    this.UpdatedPerson.BCCUSent = this.ExistingPerson.BCCUSent;
                    this.UpdatedPerson.IsSMSContactOk = this.ExistingPerson.IsSMSContactOk;
                    this.UpdatedPerson.IsEmailContactOk = this.ExistingPerson.IsEmailContactOk;
                    this.UpdatedPerson.Language = this.ExistingPerson.Language;
                    this.UpdatedPerson.IsDisabled = this.ExistingPerson.IsDisabled;
                    
                    this.UpdatedPerson.AvatarName = this.ExistingPerson.AvatarProviderName;
                    this.UpdatedPerson.SanBernardinoProviderID = this.ExistingPerson.SanBernardinoProviderID;
                    this.UpdatedPerson.PreviousAvatarProviderNames = this.ExistingPerson.PreviousAvatarProviderNames;
                    if (this.EmployeeRecord != undefined) {
                        this.UpdatedPerson.WelligentProviderID = this.EmployeeRecord.WelligentID;
                    }
                    this.UpdatedPerson.LicenseNumber = this.ExistingPerson.LicenseNumber;
                    this.UpdatedPerson.LicenseType = this.ExistingPerson.LicenseType;
                    this.UpdatedPerson.ProfessionalTitle = this.ExistingPerson.ProfessionalTitle;
                    //import phone numbers
                
                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            vm.UpdatedPerson.PhoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                
                if (this.Inline == false) {
                    this.$refs['component-modal'].show();
                }
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/Person/UpdateFullPersonRecord", this.UpdatedPerson, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                if (!this.Inline) {
                    this.$refs['component-modal'].hide();
                }
                //Perform Global Updates
                if (this.GlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
                //Fire Events if present
                if (this.DispatchOnSuccess != null) {
                    this.DispatchOnSuccess.forEach(function (item) {
                        EventBus.$emit(item);
                    });
                }
            },
            AddNewPhoneNumber() {
                this.UpdatedPerson.PhoneNumbers.push({
                    MembershipID: null,
                    PhoneNumber: "",
                    PhoneType: "",
                    Description: ""
                });
            },
            DeletePhoneNumber(phoneIndex) {
                this.UpdatedPerson.PhoneNumbers.splice(phoneIndex, 1);
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            NewDocument,
            CaseFile
        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            TargetPersonPhoneNumbers: function () {
                let phoneNumbers = [];
                if (this.ExistingPerson) {
                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            phoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                return phoneNumbers;

            },
            ParentFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.SubProgramId);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "FosterResourceParent");
            }
        },
        mounted() {
            this.ImportExistingPerson();
        }
    }
</script>

<style scoped>
</style>